import {request} from "./request";

export function getMallData(page, token) {
  return request({
    url: '/store/propGoods',
    data: {
      'page': page,
      'pageSize': 4
    }
  }, token)
}

export function buyProp(id, token) {
  return request({
    url: '/store/propBuy',
    data: {
      'propId': id,
      'amount': 1
    }
  }, token)
}
